<template>
  <div class="loader mx-auto text-xs-center">
    <v-progress-circular class="progress ma-auto" :size="50" color="primary" indeterminate />
  </div>
</template>

<script>
export default {
  noExport: true,
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  opacity: 0.5;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #fff;

  .progress {
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
  }
}
</style>